import { Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import { CommonService, DialogService} from './../../services/index';
import { Router, Routes, Route } from '@angular/router';

import { HelpComponent } from './../../system/help/help.component';
import { AboutComponent } from './../../system/about/about.component';
import { AuthHelper } from '../../shared/auth-helper';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
})

export class AdminLayoutComponent implements OnInit {
  public name: string;
  currentUser: any;
  public isAdmin = false;
  public isAdminProvider = false;
  public isCarrierAdmin = false;

  constructor(
    private router: Router,
    private dialogService: DialogService
  ) {
      this.isAdmin = AuthHelper.IsAdmin();
      this.isAdminProvider = AuthHelper.IsAdminProvider();
      this.isCarrierAdmin = AuthHelper.IsCarrierAdmin();
      this.name = AuthHelper.GetUserFullName();
  }

  ngOnInit(
  ) {
    CommonService.loadTheme();
    CommonService.themeOnClicked();
  }

  public isActive(routeElements: string[]) {
    const elements = this.router.url.split('/');
    let result = false;
    result = routeElements.some(function(value){
      const anyValue = elements.filter(el => el.indexOf(value) >= 0);
      return anyValue.length > 0;
    });
    return result;
  }

  showHelp() {
    this.dialogService.open(HelpComponent)
  }

  showAbout() {
    this.dialogService.open(AboutComponent)
  }
}
